import css from 'styled-jsx/css';

const styles = css.global`#banco-auto-25-banner {
    height: 454px;
    background: #ec0000;
}

#banco-auto-25-banner .ctn-home-24 {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 454px;
    justify-content: center;
    gap: 10px;
}

#banco-auto-25-banner .hero-img {
    margin-bottom: -10px;
}

#banco-auto-25-banner .hero-contain {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 280px;
}

#banco-auto-25-banner .hero-contain .hero-selo img {
    width: 169px;
}

#banco-auto-25-banner .hero-contain .hero-texts {
    display: flex;
    flex-direction: column;
    gap: 3px;
    width: 250px;
    margin: 0 auto;
}

#banco-auto-25-banner .hero-contain .hero-title {
    color: #FFF;
    font-family: "SantanderCondensed";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; 
}

#banco-auto-25-banner .hero-contain .hero-sub-title {
    color: #FFF;
    font-family: "SantanderMicroText";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -2%;
    width: 249px;
}

#banco-auto-25-banner .hero-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#banco-auto-25-banner .hero-buttons a {
    margin: 0 auto;
    width: 100%;
    max-width: 270px;
    height: 50px;
    border-radius: 80px;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 5px;
}

@media (min-width: 414px) {
    #banco-auto-25-banner .hero-contain {
        max-width: 326px;
    }

    /* #banco-auto-25-banner .hero-contain .hero-title {
        font-size: 35px;
        line-height: 35px;
    }

    #banco-auto-25-banner .hero-contain .hero-sub-title {
        font-size: 16px;
        letter-spacing: -0.32px;
    } */

}

@media (min-width: 600px) {
    #banco-auto-25-banner .ctn-home-24 {
        flex-direction: row-reverse;
        justify-content: space-between;
    }

    #banco-auto-25-banner .hero-img {
        margin-bottom: 0;
        max-width: 410px;
    }

    #banco-auto-25-banner .hero-img img {
        width: 100%;
        /* max-width: 452px; */
    }

    #banco-auto-25-banner .hero-contain .hero-texts {
        gap: 10px;
    }

    #banco-auto-25-banner .hero-contain .hero-title {
        font-size: 48px;
        line-height: 48px;
        position: sticky;
        width: 304px;
    }

    #banco-auto-25-banner .hero-contain {
        max-width: 242px;
        /* width: 100%; */
        gap: 76px;
    }

    #banco-auto-25-banner .hero-buttons {
        gap: 20px;
    }

    #banco-auto-25-banner .hero-buttons a {
        margin: 0;
    }
}

@media (min-width: 800px) {
    #banco-auto-25-banner .ctn-home-24 {
        justify-content: space-between;
    }

   

}

@media (min-width: 992px) {
    #banco-auto-25-banner .ctn-home-24 {
        position: relative;
    }
    
    #banco-auto-25-banner .hero-contain {
        max-width: 432px;
        margin: 0;
    }

    #banco-auto-25-banner .hero-contain .hero-texts {
        margin: 0;
        width: auto;
    }

    #banco-auto-25-banner .hero-contain .hero-title {
        font-size: 64px;
        line-height: 64px;
        width: 570px;
    }

    #banco-auto-25-banner .hero-contain .hero-sub-title {
        font-size: 25px;
        width: 475px;
    }

    #banco-auto-25-banner .hero-buttons {
        flex-direction: row;
    }
}

@media (min-width: 1100px) {
    #banco-auto-25-banner .hero-img img {
        position: absolute;
        right: 40px;
        top: 50px;
        width: 572px;
    }

    
}
/* @media (min-width: 994px) {
    #banco-auto-25-banner {
        padding-top: 15px;
    }

    #banco-auto-25-banner .ctn-home-24 {
        justify-content: space-between;
        gap: 0;
    }

    #banco-auto-25-banner .hero-img {
        max-width: 100%;
        width: 510px;
    }

    #banco-auto-25-banner .hero-contain {
        max-width: 602px;
    }

    #banco-auto-25-banner .hero-contain .hero-selo img {
        width: 332px;
    }

    #banco-auto-25-banner .hero-contain .hero-title,
    #banco-auto-25-banner .hero-contain .hero-title b {
        font-size: 63px;
        line-height: 63px;
    }

    #banco-auto-25-banner .hero-contain .hero-sub-title {
        font-size: 32px;
    }
}

@media (min-width: 1100px) {
    #banco-auto-25-banner {
        padding-top: 0;
    }
} */`;

export default styles;